module.exports = __webpack_public_path__ + "img/21812_1_full.bf8bb2c2.jpg";